import './feature-mocks.css';

import type { FeatureMockSize } from './FeatureMockFrame';
import { ProgramsPathwayMock, PROGRAMS_PATHWAY_MOCK_ALT } from './ProgramsPathwayMock';
import { WaitlistClaimMock, WAITLIST_CLAIM_MOCK_ALT } from './WaitlistClaimMock';
import {
  ExpressionOfInterestMock,
  EXPRESSION_OF_INTEREST_MOCK_ALT,
} from './ExpressionOfInterestMock';
import { PrivateRequestMock, PRIVATE_REQUEST_MOCK_ALT } from './PrivateRequestMock';

export type FeatureMockId =
  | 'programs'
  | 'waitlists'
  | 'expressions-of-interest'
  | 'private-requests';

export { FeatureMockFrame } from './FeatureMockFrame';
export type { FeatureMockSize } from './FeatureMockFrame';
export { ProgramsPathwayMock, PROGRAMS_PATHWAY_MOCK_ALT } from './ProgramsPathwayMock';
export { WaitlistClaimMock, WAITLIST_CLAIM_MOCK_ALT } from './WaitlistClaimMock';
export {
  ExpressionOfInterestMock,
  EXPRESSION_OF_INTEREST_MOCK_ALT,
} from './ExpressionOfInterestMock';
export { PrivateRequestMock, PRIVATE_REQUEST_MOCK_ALT } from './PrivateRequestMock';

const FEATURE_MOCK_ALTS: Record<FeatureMockId, string> = {
  programs: PROGRAMS_PATHWAY_MOCK_ALT,
  waitlists: WAITLIST_CLAIM_MOCK_ALT,
  'expressions-of-interest': EXPRESSION_OF_INTEREST_MOCK_ALT,
  'private-requests': PRIVATE_REQUEST_MOCK_ALT,
};

export function getFeatureMockAlt(id: FeatureMockId): string {
  return FEATURE_MOCK_ALTS[id];
}

export interface FeatureMockProps {
  id: FeatureMockId;
  size?: FeatureMockSize;
  className?: string;
}

export function FeatureMock({ id, size = 'compact', className }: FeatureMockProps) {
  switch (id) {
    case 'programs':
      return <ProgramsPathwayMock size={size} className={className} />;
    case 'waitlists':
      return <WaitlistClaimMock size={size} className={className} />;
    case 'expressions-of-interest':
      return <ExpressionOfInterestMock size={size} className={className} />;
    case 'private-requests':
      return <PrivateRequestMock size={size} className={className} />;
    default: {
      const _exhaustive: never = id;
      return _exhaustive;
    }
  }
}
